<app-home-one></app-home-one>
<app-home-three></app-home-three>
<!-- <app-home-two></app-home-two> -->
<app-schedule></app-schedule>
<!-- <app-home-five></app-home-five> -->
<div style="display: flex;flex-direction: row;justify-content:center; margin-top:20px">
    <button (click)="export()" class="submit-button">PDF EXPORT</button>
</div>